document.addEventListener('DOMContentLoaded', function () {
  // Get all ingredient blocks
  const blocks = document.querySelectorAll('.key-ingredients-block');

  blocks.forEach(function (block) {
    const blockId = block.getAttribute('data-block-id');

    // Tab functionality
    const tabButtons = block.querySelectorAll('.tab-button');
    const tabContents = block.querySelectorAll('.tab-content');

    tabButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const targetTab = button.getAttribute('data-tab');

        // Update active tab button
        tabButtons.forEach(function (btn) {
          btn.classList.remove('active');
        });
        button.classList.add('active');

        // Update active tab content
        tabContents.forEach(function (content) {
          content.classList.remove('active');
          if (content.getAttribute('data-tab-content') === targetTab) {
            content.classList.add('active');
          }
        });
      });
    });

    // Slider functionality
    const slider = block.querySelector('.ingredients-slider');
    const sliderTrack = block.querySelector('.slider-track');
    const slides = block.querySelectorAll('.ingredient-slide');
    const prevButton = block.querySelector('.slider-prev-header');
    const nextButton = block.querySelector('.slider-next-header');
    const progressCurrent = block.querySelector('.current-slide');
    const progressBarFill = block.querySelector('.progress-bar-fill');

    

    if (!slider || !sliderTrack || slides.length <= 1) {
      return;
    }

    let currentSlide = 0;
    const totalSlides = slides.length;

    function updateSlider() {
      const translateX = -currentSlide * 100;
      sliderTrack.style.transform = `translateX(${translateX}%)`;

      // Update progress text
      if (progressCurrent) {
        progressCurrent.textContent = currentSlide + 1;
      }

      // Update progress bar
      if (progressBarFill) {
        const progressWidth = ((currentSlide + 1) / totalSlides) * 100;
        progressBarFill.style.width = `${progressWidth}%`;
      }

      // Update navigation button states
      if (prevButton) {
        prevButton.disabled = currentSlide === 0;
      }
      if (nextButton) {
        nextButton.disabled = currentSlide === totalSlides - 1;
      }
    }

    function nextSlide() {
      if (currentSlide < totalSlides - 1) {
        currentSlide++;
        updateSlider();
        resetDescriptions();
      }
    }

    function prevSlide() {
      if (currentSlide > 0) {
        currentSlide--;
        updateSlider();
         resetDescriptions();
      }
    }

    function goToSlide(slideIndex) {
      if (slideIndex >= 0 && slideIndex < totalSlides) {
        currentSlide = slideIndex;
        updateSlider();
      }
    }

    // Event listeners for header navigation
    if (nextButton) {
      nextButton.addEventListener('click', function (e) {
        e.preventDefault();
        nextSlide();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', function (e) {
        e.preventDefault();
        prevSlide();
      });
    }

    // Keyboard navigation
    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') {
        prevSlide();
        e.preventDefault();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
        e.preventDefault();
      }
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;
    let touchStartY = 0;
    let touchEndY = 0;

    slider.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });

    slider.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diffX = touchStartX - touchEndX;
      const diffY = Math.abs(touchStartY - touchEndY);

      // Only trigger swipe if horizontal movement is greater than vertical
      if (Math.abs(diffX) > swipeThreshold && diffY < Math.abs(diffX)) {
        if (diffX > 0) {
          nextSlide(); // Swipe left - next slide
        } else {
          prevSlide(); // Swipe right - previous slide
        }
      }
    }

    // Initialize slider
    updateSlider();

    // Add smooth scroll behavior for better UX
    if (sliderTrack) {
      sliderTrack.style.transition = 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
    }

    // Handle image loading
    const images = block.querySelectorAll('.ingredient-image img');
    images.forEach(function(img) {
      const container = img.closest('.ingredient-image');
      
      img.addEventListener('load', function() {
        container.classList.remove('loading');
      });
      
      img.addEventListener('error', function() {
        container.classList.remove('loading');
        // You could add error styling here if needed
      });
      
      // Add loading class initially
      if (!img.complete) {
        container.classList.add('loading');
      }
    });
  });



function initIngredientDescriptions() {
  if (window.innerWidth > 991) return; // Only run below 991px

  document.querySelectorAll('.ingredient-description-wrapper').forEach(wrapper => {
    const desc = wrapper.querySelector('.ingredient-description');
    const toggle = wrapper.querySelector('.read-more-toggle');

    // Show Read more button only if content exceeds max-height
    if (desc.scrollHeight > desc.clientHeight) {
      toggle.style.display = 'inline-block';
    } else {
      toggle.style.display = 'none';
    }

    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      desc.classList.add('expanded');
      toggle.style.display = 'none'; // hide button after expanding
    });
  });
}

// Reset descriptions when slide changes
function resetDescriptions() {
  if (window.innerWidth > 991) return; // Only run below 991px

  document.querySelectorAll('.ingredient-description').forEach(desc => {
    desc.classList.remove('expanded');
  });
  document.querySelectorAll('.read-more-toggle').forEach(toggle => {
    const wrapper = toggle.closest('.ingredient-description-wrapper');
    const description = wrapper.querySelector('.ingredient-description');
    toggle.style.display = description.scrollHeight > description.clientHeight ? 'inline-block' : 'none';
  });
}

// Initialize on page load
initIngredientDescriptions();

// Optional: Reinitialize on window resize
  window.addEventListener('resize', () => {
    initIngredientDescriptions();
  });
});

// Show only the ingredients section matching the selected variant (e.g. flavour/scent)
// inside the "Ingredients" accordion. Sections are marked with <h4> headings whose text
// matches a variant's option value or title.
(function () {
  function getIngredientsContentRoot() {
    var container = document.querySelector('[data-ingredients-accordion] .accordion__content');
    if (!container) return null;
    return container.querySelector('.toggle-ellipsis__content') || container;
  }

  function buildSections(root) {
    var sections = [];
    var current = null;

    Array.prototype.forEach.call(root.children, function (el) {
      if (el.tagName === 'H4' || el.tagName === 'H3') {
        current = { heading: el, elements: [el] };
        sections.push(current);
      } else if (current) {
        current.elements.push(el);
      }
    });

    return sections;
  }

  // Reads the option values currently selected in the variant picker (radio swatches
  // and the popout-select's hidden input both use [data-single-option-selector]).
  // Used on page load, since the initial theme:variant:change event can fire before
  // this deferred script runs and gets a chance to listen for it.
  function getSelectedOptionValues() {
    var inputs = document.querySelectorAll('[data-single-option-selector]');
    var values = [];

    inputs.forEach(function (input) {
      if (input.type === 'radio' && !input.checked) return;
      if (input.value) values.push(input.value.trim().toLowerCase());
    });

    return values;
  }

  function applyVariantIngredients(variant) {
    var root = getIngredientsContentRoot();
    if (!root) return;

    var sections = buildSections(root);
    if (!sections.length) return;

    var variantValues = variant
      ? [variant.option1, variant.option2, variant.option3, variant.title]
          .filter(Boolean)
          .map(function (value) { return value.trim().toLowerCase(); })
      : getSelectedOptionValues();

    var matched = sections.find(function (section) {
      var headingText = section.heading.textContent.trim().toLowerCase();
      return variantValues.indexOf(headingText) !== -1;
    });

    // If nothing matches (e.g. heading text doesn't line up with any option value),
    // show everything rather than hiding the whole list.
    sections.forEach(function (section) {
      var visible = !matched || section === matched;
      section.elements.forEach(function (el) {
        el.style.display = visible ? '' : 'none';
      });
    });
  }

  document.addEventListener('theme:variant:change', function (event) {
    applyVariantIngredients(event.detail && event.detail.variant);
  });

  // Apply immediately using the server-rendered selection, in case the initial
  // theme:variant:change event already fired before this script loaded.
  applyVariantIngredients();
})();